import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EmptySectionComponent } from '../empty-section.component';
import { EmptySectionMatchesColorOfFollowingProductSection } from '../../../../../../../../../models/menu/section/empty-section-matches-color-of-following-product-section';

@Component({
  selector: 'app-empty-section-matches-color-of-following-product-section',
  templateUrl: './empty-section-matches-color-of-following-product-section.component.html',
  styleUrl: './empty-section-matches-color-of-following-product-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EmptySectionMatchesColorOfFollowingProductSectionComponent extends EmptySectionComponent {
  @Input() override section: EmptySectionMatchesColorOfFollowingProductSection;
}
